import { render } from "./App.vue?vue&type=template&id=5b6521c2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5b6521c2&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\projects\\tahdir-v2\\tahdir-students-scan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__